import { useEffect, useState } from 'react'
import { unidadesRoutes } from '../routes'
import { imageDatabase } from '../indexedDB'

/**
 * Custom hook to manage master data like 'unidades' and generic offline images.
 * This abstracts data fetching and caching logic from components/contexts.
 */
export const useMasterData = () => {
    const [unidades, setUnidades] = useState([])
    const [imagenesGenericasOfLine, setImagenesGenericasOfLine] = useState([])

    useEffect(() => {
        // Load/Cache generic images on mount
        guardarImagenesLocales()
    }, [])

    const getUnidades = async () => {
        try {
            const response = await unidadesRoutes.getUnidades()
            if (response && Array.isArray(response.data)) { // Original Auth.context.jsx checked response.data.data
                const units = response.data
                setUnidades(units)
                localStorage.setItem('unidades', JSON.stringify(units))
            } else if (response && Array.isArray(response.data.unidades)) { // This matches original structure
                const units = response.data.unidades
                setUnidades(units)
                localStorage.setItem('unidades', JSON.stringify(units))
            } else {
                console.error('Failed to fetch unidades or data is not an array. Response data:', response?.data)
            }
        } catch (error) {
            console.error('Error fetching unidades:', error)
        }
    }

    const guardarImagenesLocales = async () => {
        const images = [
            {
                id: 0,
                name: 'noImage',
                path: './assets/no-image-icon-6.webp',
                pathBase64: ''
            },
            {
                id: 1,
                name: 'noImageProfile',
                path: './assets/no-profile-image.webp',
                pathBase64: ''
            }
        ]

        try {
            const { database } = await imageDatabase.initDb()

            // Use for...of to properly await each async operation sequentially
            for (const imagen of images) {
                try {
                    const response = await fetch(imagen.path)
                    const blob = await response.blob()
                    const base64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader()
                        reader.onloadend = () => resolve(reader.result)
                        reader.onerror = reject
                        reader.readAsDataURL(blob)
                    })

                    const imageCache = { ...imagen, pathBase64: base64 }
                    await imageDatabase.actualizar(imageCache, database)
                } catch (error) {
                    console.error('Error fetching local image:', imagen.path, error)
                }
            }

            setImagenesGenericasOfLine(images)
        } catch (error) {
            console.error('Error initializing image database:', error)
        }
    }

    return {
        unidades,
        imagenesGenericasOfLine,
        getUnidades // Expose refresh function if needed by consumers
    }
}
